import type { AssigneeOption, StatusOption, TaskTypeOption } from './Filter.vue';
import type { OverviewTaskItem } from './useOverviewTaskParser';

type FilterTasksArgs = {
  assignee: AssigneeOption;
  taskType: TaskTypeOption;
  status: StatusOption;
  overviewTaskItems: OverviewTaskItem[];
};

export const useOverviewTaskFilter = () => {
  const filterTasks = ({ assignee, taskType, status, overviewTaskItems }: FilterTasksArgs) => {
    return overviewTaskItems.filter(taskItem => {
      const matchesTaskType = filterTaskType(taskType, taskItem);
      const matchesAssignee = filterAssignee(assignee, taskItem);
      const matchesStatus = filterStatus(status, taskItem);
      return matchesTaskType && matchesAssignee && matchesStatus;
    });
  };
  return { filterTasks };
};

const filterTaskType = (taskType: TaskTypeOption, overviewTaskItem: OverviewTaskItem) => {
  if (taskType === 'All') return true;
  return overviewTaskItem.taskTypeOption === taskType;
};

const filterAssignee = (assignee: AssigneeOption, overviewTaskItem: OverviewTaskItem) => {
  if (assignee === 'All') return true;
  return overviewTaskItem.assigneeOption === assignee;
};

const filterStatus = (status: StatusOption, overviewTaskItem: OverviewTaskItem) => {
  if (status === 'All') return true;
  return overviewTaskItem.statusOption === status;
};
